import React, { useCallback } from 'react';

import { OnClick } from '@rbilabs/components-library';
import { useNavigate } from 'react-router-dom';

import { TextWithArrowButton } from 'components/text-with-arrow-button';
import { CustomEventNames, useMParticleContext } from 'state/mParticle';
import { routes } from 'utils/routing';

import { ContentBlock, FullLineSeparator, TextButtonsWrapper } from '../../styled';

export const PhysicalCardContentSection = ({ onDismiss }: { onDismiss: OnClick }) => {
  const mParticle = useMParticleContext();
  const navigate = useNavigate();

  const handleGoToRoute = useCallback(
    (e, route: string) => {
      onDismiss(e);
      navigate(route, { replace: true });
      if (route === routes.addCard) {
        mParticle.logNavigationClick(CustomEventNames.BUTTON_CLICK_REGISTER_PHYSICAL_CARD);
      }
    },
    [onDismiss, navigate, mParticle]
  );

  return (
    <ContentBlock margin="0 0 5rem">
      <TextButtonsWrapper>
        <FullLineSeparator margin={`0`} />
        <TextWithArrowButton
          onClick={() => handleGoToRoute('', routes.timsRewards)}
          messageId="registerYourPhysicalCard"
        />
        <FullLineSeparator margin={`0`} />
      </TextButtonsWrapper>
    </ContentBlock>
  );
};

export default PhysicalCardContentSection;
